module.exports = __webpack_public_path__ + "static/img/vivodcb2.0e81860e.png";